import styles from "./styles.scss";
import { forwardRef } from "react";
import clsx from "clsx";
import { ButtonProps } from "./types";
import { ButtonVariant } from "@/components";

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = ButtonVariant.Primary,
      size,
      children,
      icon,
      className,
      labelClassName,
      type = "button",
      ...props
    },
    ref,
  ) => (
    <button
      ref={ref}
      {...props}
      type={type}
      className={clsx(
        styles.button,
        variant && styles[variant],
        size && styles[size],
        className,
      )}
    >
      {icon && <span className={styles.icon}>{icon}</span>}
      {!!children && (
        <span className={clsx(styles.label, labelClassName)}>{children}</span>
      )}
    </button>
  ),
);

Button.displayName = "Button";
